/* Separadores de las secciones (olas, picos...): si la sección es blanca y la de al lado también,
   el separador se pinta con el color de la tienda en vez de blanco (blanco sobre blanco no se vería).
   Si la sección de al lado tiene color, se queda como siempre (del color de su propia sección). */
(function () {
  function rgb(c) {
    var m = c && c.match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    var p = m[1].split(',').map(parseFloat);
    return (p.length < 4 || p[3] > 0.05) ? p : null;
  }
  function bgOf(el) {
    while (el && el !== document.documentElement) {
      var cs = getComputedStyle(el);
      if (cs.backgroundImage && cs.backgroundImage !== 'none') return 'img';
      var c = rgb(cs.backgroundColor);
      if (c) return c;
      el = el.parentElement;
    }
    return rgb(getComputedStyle(document.body).backgroundColor) || [255, 255, 255];
  }
  function isWhite(c) { return c !== 'img' && c[0] > 238 && c[1] > 238 && c[2] > 238; }
  function inner(sec) {
    if (!sec) return null;
    for (var i = 0; i < sec.children.length; i++) {
      var ch = sec.children[i];
      if (/^(STYLE|SCRIPT|LINK|TEMPLATE)$/.test(ch.tagName)) continue;
      return ch;
    }
    return sec;
  }
  function run() {
    var all = [].slice.call(document.querySelectorAll('.shopify-section'));
    [].forEach.call(document.querySelectorAll('.dv-sep-on'), function (el) {
      var sec = el.closest('.shopify-section'), i = all.indexOf(sec);
      var ownW = isWhite(bgOf(el));
      var t = /(^|\s)dv-sept--/.test(el.className), b = /(^|\s)dv-sepb--/.test(el.className);
      var prev = i > 0 ? inner(all[i - 1]) : null, next = i > -1 && i < all.length - 1 ? inner(all[i + 1]) : null;
      el.classList.toggle('dv-sept-accent', t && ownW && (!prev || isWhite(bgOf(prev))));
      el.classList.toggle('dv-sepb-accent', b && ownW && (!next || isWhite(bgOf(next))));
    });
  }
  var tm; function later() { clearTimeout(tm); tm = setTimeout(run, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (ev) { document.addEventListener(ev, later); });
})();

/* Formulario de contacto: las palabras en negrita del texto se ven en el color de la tienda, y el email también. */
(function () {
  if (document.getElementById('dv-cf-extra')) return;
  var st = document.createElement('style');
  st.id = 'dv-cf-extra';
  st.textContent = '.dv-cf__intro strong,.dv-cf__intro b{color:var(--cf-hl,var(--accent,#3e694d))}' +
    '.dv-bgs--on-dark .dv-cf__intro strong,.dv-bgs--on-dark .dv-cf__intro b{color:inherit;text-decoration:underline}' +
    '.dv-cf__info a{color:var(--accent,#3e694d)!important;font-weight:600}' +
    '.dv-bgs--on-dark .dv-cf__info a{color:inherit!important}';
  (document.head || document.documentElement).appendChild(st);
})();

/* «Qué incluye» cambia según la oferta elegida: las líneas que empiezan por «x1 …» pasan a
   «x2 lápices + 1 gratis» (pagadas + gratis) en la oferta de varias unidades, y vuelven a «x1» en la de una. */
(function () {
  function plural(w) {
    if (/z$/i.test(w)) return w.slice(0, -1) + 'ces';
    if (/[áéíóú]n$/i.test(w)) return w.slice(0, -2) + w.slice(-2, -1).normalize('NFD').replace(/[̀-ͯ]/g, '') + 'nes';
    if (/[aeiouáéíóú]$/i.test(w)) return w + 's';
    return w + 'es';
  }
  function lines(acc) {
    var box = acc.querySelector('.drevia-accordion__content');
    if (!box) return null;
    if (!box.hasAttribute('data-dv-orig')) {
      if (!/(^|>|\s)x1\s/i.test(box.innerHTML)) return null;
      box.setAttribute('data-dv-orig', box.innerHTML);
    }
    return box;
  }
  function update() {
    var sel = document.querySelector('.drevia-offer.is-selected') || document.querySelector('.drevia-offer input:checked');
    if (sel && !sel.classList.contains('drevia-offer')) sel = sel.closest('.drevia-offer');
    var q = sel ? parseInt(sel.getAttribute('data-quantity'), 10) || 1 : 1;
    var c = sel ? parseInt(sel.getAttribute('data-charged-quantity'), 10) || q : q;
    if (c > q) c = q;
    var f = q - c;
    [].forEach.call(document.querySelectorAll('.drevia-accordion'), function (acc) {
      var box = lines(acc);
      if (!box) return;
      var orig = box.getAttribute('data-dv-orig');
      if (q <= 1) { if (box.innerHTML !== orig) box.innerHTML = orig; return; }
      var first = true;
      var html = orig.replace(/x1\s+([^\s<]+)([^<]*)/gi, function (m, word, rest) {
        var out;
        if (first) {
          out = 'x' + c + ' ' + plural(word) + rest.replace(/\s+$/, '') + (f > 0 ? ' + ' + f + ' gratis' : '');
          first = false;
        } else {
          out = 'x' + q + ' ' + plural(word) + rest;
        }
        return out;
      });
      if (box.innerHTML !== html) box.innerHTML = html;
    });
  }
  var tm; function later() { clearTimeout(tm); tm = setTimeout(update, 30); }
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.drevia-offer')) later(); });
  document.addEventListener('change', later);
  function watch() {
    update();
    if (window.MutationObserver) {
      var mo = new MutationObserver(later);
      [].forEach.call(document.querySelectorAll('.drevia-offer'), function (o) { mo.observe(o, { attributes: true, attributeFilter: ['class'] }); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  document.addEventListener('shopify:section:load', later);
})();
